module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Layout/Layout-top-panel-5-18a1bf2f6ea5b7ed82904238363525f1.svg";